/**
 * RevenueChart — динамика выручки клиники (recharts): бары нетто по дням
 * или месяцам, тултип с приходом/возвратами. Hex — палитра чартов.
 */

import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis} from 'recharts';

import type {RevenuePoint} from '@services/reports';
import {formatNumber} from '@utils/format';

import {fmtBucket} from '../Reports.utils';

type Props = {
  points: RevenuePoint[];
  groupBy: 'day' | 'month';
};

export const RevenueChart = ({points, groupBy}: Props) => (
  <div className="rounded-[15px] border border-skr-line bg-card px-[18px] pb-4 pt-[15px]">
    <div className="mb-3 text-[13.5px] font-semibold">
      Динамика выручки · {groupBy === 'day' ? 'по дням' : 'по месяцам'}
    </div>
    {points.length === 0 ? (
      <div className="flex h-[190px] items-center justify-center text-[12.5px] text-muted-foreground">
        Данных за период нет
      </div>
    ) : (
      <div className="h-[190px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={points} margin={{top: 6, right: 4, left: 4, bottom: 0}}>
            <CartesianGrid vertical={false} stroke="#EDEFF3" />
            <XAxis
              dataKey="bucket"
              tickFormatter={(b) => fmtBucket(String(b), groupBy)}
              tickLine={false}
              axisLine={false}
              tick={{fontSize: 11, fill: '#8A8F99', fontFamily: 'JetBrains Mono, monospace'}}
              dy={4}
              interval="preserveStartEnd"
            />
            <Tooltip
              cursor={{fill: '#F3F5F9'}}
              formatter={(value: number | string, name: string) => [
                formatNumber(Number(value)),
                name === 'net' ? 'Нетто' : name === 'income' ? 'Приход' : 'Возвраты',
              ]}
              labelFormatter={(b) => fmtBucket(String(b), groupBy)}
              contentStyle={{
                borderRadius: 10,
                border: '1px solid #E4E7EC',
                fontSize: 12,
                padding: '8px 11px',
              }}
            />
            <Bar dataKey="net" fill="#2C5CDB" radius={[5, 5, 0, 0]} maxBarSize={26} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    )}
  </div>
);
